import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
        <div className="w-full lg:w-[30%]">
          <span className="inline-block px-4 py-1.5 border border-foreground-200 rounded-full text-foreground-500 font-label text-xs font-medium mb-6">
            What's Inside
          </span>
          <div className="w-full aspect-square rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Bright%20modern%20studio%20flat%20lay%20with%20colorful%20fashion%20accessories%20including%20tortoise%20shell%20sunglasses%2C%20cognac%20leather%20watch%2C%20woven%20bracelets%2C%20rose%20gold%20rings%2C%20and%20miniature%20fragrance%20bottles%20artfully%20arranged%20on%20crisp%20white%20marble%20surface%2C%20natural%20window%20light%20streaming%20from%20upper%20right%2C%20luxury%20editorial%20catalog%20photography%2C%20clean%20and%20crisp%20composition%20with%20subtle%20reflections&width=800&height=800&seq=about-img-v2-004&orientation=squarish"
              alt="Superbuy Spreadsheet organized product resources"
              title="Superbuy Spreadsheet shopping resources"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="w-full lg:w-[70%]">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
            Your Ultimate<br />
            Shopping<br />
            Resource
          </h2>

          <p className="text-foreground-600 text-base leading-relaxed mb-4 max-w-2xl">
            Superbuy Spreadsheet is a structured resource platform designed to help shoppers discover organized product collections, verified shopping links, and comprehensive buying guides. Unlike scattered search results, our Superbuy spreadsheet links provide a centralized hub where you can browse 14 curated categories — from shoes and hoodies to accessories and perfumes — all updated regularly for the 2026 shopping season.
          </p>

          <p className="text-foreground-600 text-base leading-relaxed mb-4 max-w-2xl">
            Whether you are searching for the latest sneaker finds or building a Superbuy product database for comparison shopping, this resource eliminates the guesswork. Each category entry connects directly to detailed product pages, saving you hours of manual searching. The platform prioritizes accuracy, regular updates, and a beginner-friendly approach so anyone can navigate the Superbuy spreadsheet finds with confidence.
          </p>

          <p className="text-foreground-500 text-sm leading-relaxed mb-8 max-w-2xl">
            <Link to="/" className="text-accent-700 hover:text-accent-800 underline underline-offset-2 cursor-pointer transition-colors duration-150">
              Back to Hub
            </Link>
            {' '}— your central starting point for all Superbuy Spreadsheet resources.
          </p>

          <Link
            to="/superbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-950 text-background-50 rounded-lg font-label font-semibold text-sm hover:bg-foreground-800 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Read The Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}